import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['usergroups'], ({ usergroups }) => usergroups.audit, 'usergroup');
